import { People } from '@/components/icons'

export const StatsLoading = () => {
  return (
    <div className="animate-pulse dark:bg-slate-400 p-2 w-20 shadow rounded-lg flex flex-col gap-y-2">
      <div className="flex w-full items-center">
        <People className="text-slate-300" />
        <div className="h-2 w-full bg-slate-300 ml-1 rounded-full" />
      </div>
      <div className="bg-slate-300 rounded-full h-4 py-1" />
    </div>
  )
}

export const ProfileLoading = () => {
  return (
    <div className="animate-pulse bg-slate-400 p-2 shadow rounded-lg flex flex-col md:flex-row md:items-center gap-y-2 md:gap-x-6">
      <div className="flex items-center gap-x-4 md:gap-x-6">
        <div className="w-16 h-16 md:w-24 md:h-24 bg-slate-300 rounded-full"></div>
        <div className="flex flex-col font-semibold w-64">
          <div className="w-28 bg-slate-300 h-4 rounded-full"></div>
          <div className="w-36 bg-slate-300 h-4 rounded-full mt-1"></div>
        </div>
      </div>
      <div className="flex gap-x-10">
        <div className="w-20 h-6 bg-slate-300 rounded-full"></div>
        <div className="w-20 h-6 bg-slate-300 rounded-full"></div>
      </div>
    </div>
  )
}

export const FollowerLoading = () => {
  return (
    <div className="animate-pulse mt-2 bg-slate-400 p-2 shadow rounded-lg flex items-center justify-between">
      <div className="flex items-center  gap-x-2">
        <div className="w-12 h-12 bg-slate-300 rounded-full" />
        <div className="w-28 h-4 bg-slate-300 rounded-full" />
      </div>
      <div className="w-20 h-7 bg-slate-300 rounded-full"></div>
    </div>
  )
}

export const MatchItemLoading = () => {
  return (
    <div className="animate-pulse dark:bg-slate-400 shadow rounded-2xl p-4 md:py-4 md:px-6">
      <div className="flex justify-between">
        <div className="bg-slate-300 rounded-full h-4 w-20" />
        <div className="bg-slate-300 rounded-full h-4 w-20" />
      </div>

      <div className="flex mt-3 gap-x-4">
        <div className="flex-1">
          <div className="flex justify-between items-end flex-1">
            <div className="flex flex-1 flex-col w-6/12">
              <div className="flex justify-between items-center py-1">
                <div className="flex items-center">
                  <div className="md:w-5 md:h-5 w-4 h-4 rounded-full bg-slate-300" />
                  <div className="ml-2 h-4 w-20 bg-slate-300 rounded-full" />
                </div>
              </div>

              <div className="flex justify-between items-center py-1">
                <div className="flex items-center">
                  <div className="md:w-5 md:h-5 w-4 h-4 rounded-full bg-slate-300" />
                  <div className="ml-2 h-4 w-20 bg-slate-300 rounded-full" />
                </div>
              </div>
            </div>
            <div className={`hidden md:flex justify-center items-center w-1/12`} />
            <div className="flex md:gap-x-6 gap-x-2 items-center w-5/12 justify-end">
              <div className="bg-slate-300 w-5 h-3 rounded-full" />
              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />
            </div>
          </div>

          <div className="h-[0.5px] bg-black bg-opacity-10 md:my-2 my-1" />

          <div className="flex justify-between items-start flex-row flex-1">
            <div className="flex flex-1 flex-col w-6/12">
              <div className="flex justify-between items-center py-1">
                <div className="flex items-center">
                  <div className="md:w-5 md:h-5 w-4 h-4 rounded-full bg-slate-300" />
                  <div className="ml-2 h-4 w-20 bg-slate-300 rounded-full" />
                </div>
              </div>

              <div className="flex justify-between items-center py-1">
                <div className="flex items-center">
                  <div className="md:w-5 md:h-5 w-4 h-4 rounded-full bg-slate-300" />
                  <div className="ml-2 h-4 w-20 bg-slate-300 rounded-full" />
                </div>
              </div>
            </div>
            <div className={`hidden md:flex justify-center items-center w-1/12`} />
            <div className="flex md:gap-x-6 gap-x-2 items-center w-5/12 justify-end">
              <div className="bg-slate-300 w-5 h-3 rounded-full" />
              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />

              <div className="bg-slate-300 w-5 h-3 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const PlayerItemLoading = ({ isFilter, className }: { isFilter?: boolean; className?: string }) => {
  return (
    <div
      className={`animate-pulse flex p-4 justify-between dark:bg-slate-400 rounded-2xl xl:max-w-[640px] 2xl:max-w-[720px] ${className} ${
        isFilter ? 'lg:max-w-[432px]' : 'lg:max-w-[640px]'
      }`}
    >
      <div className="flex gap-x-2">
        <div className="rounded-full w-10 h-10 bg-slate-300" />
        <div className="flex flex-col gap-y-2">
          <div className="bg-slate-300 w-28 h-3 rounded-full" />
          <div className="bg-slate-300 w-28 h-2 rounded-full" />
          <div className="bg-slate-300 w-28 h-2 rounded-full" />
        </div>
      </div>
      <div className="flex gap-x-1 items-center">
        <div className="bg-slate-300 rounded-lg w-11 h-10" />
        <div className="bg-slate-300 rounded-lg w-11 h-10" />
      </div>
    </div>
  )
}

export const BracketPaymentLoading = () => {
  return (
    <div className={`animate-pulse flex p-4 justify-between bg-slate-400 rounded-2xl max-w-[964px]`}>
      <div className="flex gap-x-2">
        <div className="rounded-full w-10 h-10 bg-slate-300" />
        <div className="flex flex-col gap-y-2">
          <div className="bg-slate-300 w-28 h-3 rounded-full" />
          <div className="bg-slate-300 w-28 h-2 rounded-full" />
          <div className="bg-slate-300 w-28 h-2 rounded-full" />
        </div>
      </div>
      <div className="flex flex-col gap-y-1">
        <div className="bg-slate-300 rounded w-40 h-3" />
        <div className="bg-slate-300 rounded w-40 h-2" />
        <div className="bg-slate-300 rounded w-6 h-2" />
      </div>
    </div>
  )
}

export const BracketQueueLoading = () => {
  return (
    <div className={`animate-pulse flex p-4 justify-between bg-slate-400 rounded-2xl max-w-[964px]`}>
      <div className="w-4 h-4 rounded bg-slate-300" />
      <div className="flex flex-1 gap-x-4 pt-8">
        <div className="flex flex-col gap-y-4 flex-1 justify-between">
          <div className="w-full h-4 bg-slate-300 rounded" />
          <div className="w-full h-4 bg-slate-300 rounded" />
        </div>
        <div className="flex items-center justify-center">
          <div className="w-6 h-6 bg-slate-300 rounded-full" />
        </div>
        <div className="flex flex-col gap-y-4 flex-1 justify-between">
          <div className="w-full h-4 bg-slate-300 rounded" />
          <div className="w-full h-4 bg-slate-300 rounded" />
        </div>
      </div>
      <div className="w-28 h-4 rounded bg-slate-300" />
    </div>
  )
}

export const BracketTeamItemLoading = ({ isFilter, className }: { isFilter?: boolean; className?: string }) => {
  return (
    <div
      className={`animate-pulse flex flex-col gap-y-4 p-4 dark:bg-slate-400 rounded-2xl xl:max-w-[640px] 2xl:max-w-[720px] ${className} ${
        isFilter ? 'lg:max-w-[432px]' : 'lg:max-w-[640px]'
      }`}
    >
      <div className="w-full flex justify-between items-center">
        <div className="w-16 h-4 rounded-full bg-slate-300" />
        <div className="w-28 h-4 rounded-full bg-slate-300" />
      </div>
      <div className="w-full flex flex-col gap-y-6">
        <div className="flex justify-between">
          <div className="flex gap-x-2">
            <div className="rounded-full w-10 h-10 bg-slate-300" />
            <div className="flex flex-col gap-y-2">
              <div className="bg-slate-300 w-28 h-3 rounded-full" />
              <div className="bg-slate-300 w-28 h-2 rounded-full" />
              <div className="bg-slate-300 w-28 h-2 rounded-full" />
            </div>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="bg-slate-300 rounded-lg w-11 h-10" />
            <div className="bg-slate-300 rounded-lg w-11 h-10" />
          </div>
        </div>

        <div className="flex justify-between">
          <div className="flex gap-x-2">
            <div className="rounded-full w-10 h-10 bg-slate-300" />
            <div className="flex flex-col gap-y-2">
              <div className="bg-slate-300 w-28 h-3 rounded-full" />
              <div className="bg-slate-300 w-28 h-2 rounded-full" />
              <div className="bg-slate-300 w-28 h-2 rounded-full" />
            </div>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="bg-slate-300 rounded-lg w-11 h-10" />
            <div className="bg-slate-300 rounded-lg w-11 h-10" />
          </div>
        </div>
      </div>
    </div>
  )
}

export const MyClubItemLoading = () => {
  return (
    <div className="animate-pulse rounded-lg dark:bg-slate-400 md:flex md:flex-row flex flex-col gap-y-2 md:gap-x-2 min-w-[120px] md:min-w-[235px] py-3 md:items-start items-center">
      <div className="w-10 h-10 rounded-full bg-slate-300" />
      <div className="flex flex-col items-center md:items-start gap-y-1">
        <div className="w-40 h-4 rounded-full bg-slate-300 max-w-[100px] md:max-w-[180px]" />
        <div className="w-32 h-2 rounded-full bg-slate-300 hidden md:inline" />
        <div className="w-20 h-2 rounded-full bg-slate-300" />
      </div>
    </div>
  )
}

export const ClubItemLoading = () => {
  return (
    <div className="animate-pulse rounded-2xl dark:bg-slate-400 flex flex-row gap-x-2 w-full md:w-[312px] py-3 pl-3 items-start">
      <div className="w-10 h-10 rounded-full bg-slate-300" />
      <div className="flex flex-col items-start gap-y-1">
        <div className="w-40 h-4 rounded-full bg-slate-300 max-w-[180px]" />
        <div className="w-32 h-2 rounded-full bg-slate-300" />
        <div className="w-20 h-2 rounded-full bg-slate-300" />
      </div>
    </div>
  )
}

export const EventItemLoading = ({ className }: { className?: string }) => {
  return (
    <div className={`animate-pulse dark:bg-slate-400 bg-white rounded-2xl px-4 py-3 flex gap-x-2 ${className}`}>
      <div className="w-11 h-10 bg-slate-300 rounded-full" />
      <div className="w-full flex flex-col gap-y-2">
        <div className="flex justify-between items-center">
          <div className="w-32 h-4 rounded-full bg-slate-300" />
          <div className="w-10 h-4 rounded-full bg-slate-300" />
        </div>
        <div className="w-32 h-2 rounded-full bg-slate-300" />
        <div className="w-32 h-2 rounded-full bg-slate-300" />
        <div className="w-32 h-2 rounded-full bg-slate-300" />
      </div>
    </div>
  )
}

export const EventDetailHeaderLoading = () => {
  return (
    <div className="animate-pulse max-w-[640px] flex">
      <div className="w-11 h-10 rounded-full bg-slate-300" />
      <div className="w-full flex flex-col gap-y-2 ml-3">
        <div className="w-40 h-4 bg-slate-300 rounded-full" />
        <p className="w-80 h-3 bg-slate-300 rounded-full"></p>
        <p className="w-40 h-2 bg-slate-300 rounded-full"></p>
        <div className="w-60 h-8 bg-slate-300 rounded-full my-3" />
        <div className="w-20 h-10 bg-slate-300 rounded-full" />
      </div>
    </div>
  )
}

export const SkeletonMainLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="animate-pulse flex flex-col gap-y-2">{children}</div>
}

const SkeletonMainSidebar = () => {
  return (
    <div className="animate-pulse bg-slate-400 w-1/4 h-screen rounded-lg">
      <div className="h-full w-full bg-slate-300 rounded-lg" />
    </div>
  )
}

const SkeletonMainContent = () => {
  return (
    <div className="animate-pulse bg-slate-400 w-3/4 h-screen rounded-lg">
      <div className="h-full w-full bg-slate-300 rounded-lg" />
    </div>
  )
}

export const SkeletonAppLoading = () => {
  return (
    <SkeletonMainLayout>
      <SkeletonMainSidebar />
      <SkeletonMainContent />
    </SkeletonMainLayout>
  )
}
